export const DEFAULT_PAGE_SIZE = 10;
export const PAGE_SIZE_OPTIONS = [10, 20, 30, 50, 100];

export const LOCAL_STORAGE_KEYS = {
  IS_HIDE: '-isHide',
  COLUMN_ORDER: '-columnOrder',
  ROWS_PER_PAGE: '-rowsPerPage',
  FILTERS: '-filters',
} as const;

export const Z_INDEX = {
  STICKY_HEADER: 3,
  STICKY_COLUMN: 1,
} as const;

export const DROPDOWN_CLASS = 'dropdown-menu';
export const PLACEHOLDER_CLASS = 'placeholder';
export const ACTIVE_CLASS = 'active';
export const DISABLED_CLASS = 'disabled';

export const DEFAULT_TABLE_HEIGHT = '500px';
export const DEFAULT_REFRESH_COUNTDOWN = 5;

export const STORAGE_KEY_PREFIX = 'datatable';
